import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "./lib/i18n";
import { ThemeProvider } from "./lib/theme";
import Layout from "./components/Layout";
import Simulator from "./pages/Simulator";
import Instructions from "./pages/Instructions";
import Company from "./pages/Company";
import Compare from "./pages/Compare";
import Embed from "./pages/Embed";

function App() {
  return (
    <div className="App wc-app">
      <ThemeProvider>
        <I18nProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/embed" element={<Embed />} />
              <Route element={<Layout />}>
                <Route path="/" element={<Simulator />} />
                <Route path="/confronta" element={<Compare />} />
                <Route path="/istruzioni" element={<Instructions />} />
                <Route path="/azienda" element={<Company />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </I18nProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
